<template>
    <LayoutModal v-model="model">
        <div
            class="max-h-screen w-full max-w-xl border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col"
        >
            <div class="flex-shrink-0 flex items-center p-4 sm:p-6 space-x-4">
                <p class="text-left flex-grow text-lg font-medium ct-text-1">
                    {{ $t("shared.impersonate.modal_title") }}
                </p>
                <ButtonCloseSmXs @click="handleCancel()" />
            </div>
            <div class="flex-grow overflow-y-auto mx-8 mb-4 space-y-6 justify-start">
                <FormInput
                    :title="$t('shared.impersonate.easy_id')"
                    v-model="formValue.easyId"
                    @blur="v$.easyId.$touch"
                    :error="v$.easyId.$errors?.[0]?.$message"
                />
                <FormTextArea
                    :title="$t('shared.impersonate.reason')"
                    v-model="formValue.reason"
                    @blur="v$.reason.$touch"
                    :error="v$.reason.$errors?.[0]?.$message"
                />
                <div class="flex space-x-3 mt-3">
                    <ButtonSecondaryMd class="flex-1" @click="handleCancel()">
                        {{ $t("shared.cancel") }}
                    </ButtonSecondaryMd>
                    <ButtonPrimaryMd class="flex-1" @click="handleImpersonate()">
                        {{ $t("shared.impersonate.start") }}
                    </ButtonPrimaryMd>
                </div>
            </div>
        </div>
    </LayoutModal>
</template>

<script>
import { LayoutModal } from "@easy/ui/layouts";
import { FormInput, FormTextArea } from "@easy/ui/forms";
import { ButtonPrimaryMd, ButtonSecondaryMd } from "@easy/ui/buttons";
import { ButtonCloseSmXs } from "@easy/ui/buttons";
import { useFormValidation } from "@/shared/utils/forms/useFormValidation";
import { required } from "@/shared/utils/forms/i18n-vuelidators";
import { reactive } from "vue";
import { impersonateService } from "@/auth/service/impersonate.service";
import { mapGetters } from "vuex";

export default {
    components: {
        FormInput,
        FormTextArea,
        ButtonPrimaryMd,
        ButtonSecondaryMd,
        ButtonCloseSmXs,
        LayoutModal,
    },
    props: {
        modelValue: Boolean,
    },
    emits: ["update:modelValue"],
    setup() {
        const rules = {
            easyId: { required },
            reason: { required },
        };
        const formValue = reactive({
            easyId: "",
            reason: "",
        });
        const { v$, validateForm, resetFrom } = useFormValidation(rules, formValue);
        return {
            v$,
            validateForm,
            resetFrom,
            formValue,
        };
    },
    computed: {
        ...mapGetters(["appUrl", "easyUrls"]),
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        async handleImpersonate() {
            const isOk = await this.validateForm();
            if (!isOk) {
                return;
            }
            try {
                const { easyId, reason } = this.formValue;
                await impersonateService.startSession(easyId, reason);
                await this.resetFrom();
                window.location = this.appUrl + `/projects-list`;
            } catch {
                /* empty */
            }
        },
        async handleCancel() {
            this.model = false;
            Object.assign(this.formValue, { easyId: "", reason: "" });
            await this.resetFrom();
        },
    },
};
</script>
